export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(n || 0);

export const eurShort = (n) => {
  const v = n || 0;
  if (Math.abs(v) >= 1000) return `€ ${(v / 1000).toLocaleString("it-IT", { maximumFractionDigits: 1 })}k`;
  return `€ ${v.toLocaleString("it-IT")}`;
};

export const num = (n) =>
  new Intl.NumberFormat("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const STATO_LABELS = {
  attivo: "Attivo",
  in_pausa: "In Pausa",
  completato: "Completato",
};

export const STATO_BADGE = {
  attivo: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300 border-emerald-300/50",
  in_pausa: "bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300 border-amber-300/50",
  completato: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 border-slate-300/50",
};

export const CHART_COLORS = [
  "#D97706", "#0F172A", "#3B82F6", "#10B981", "#8B5CF6", "#EC4899", "#F59E0B", "#14B8A6", "#EF4444",
];
